<template>
  <article>
    <!-- Make linkable card possible (and optional) -->
    <router-link
      :to="`${options.url}`"
      v-if="options.url"
      class="card__link"
    ></router-link>

    <div class="card__heading-content">
      <h6 class="card__title">{{ options.title }}</h6>

      <a class="card__show-more" href="#" v-if="options.showMore">Visa mer</a>
      <p class="card__updated" v-if="options.updatedLast">
        {{ options.updatedLast }}
        <img class="card__updated-img" src="../../assets/svg/updated.svg">
      </p>
    </div>

    <section v-if="options.dataType === 'multiple'" class="card__items">
      <div class="card__multiple">
        <div
          :key="i"
          v-for="(item, i) in options.items"
          class="card__item"
        >
          <p class="card__subtitle"> {{ item.subtitle }} </p>
          <span v-if="item.value != 'X'" class="card__data">
            <p :class="'card__value-' + item.valueType">
              {{ item.value }}
            </p>

            <img
              v-if="item.info"
              class="card__info-image"
              src="../../assets/img/info.png"
              alt="info"
            >
          </span>

          <span v-else>
            <p class="card__no-value">
              Vi behöver att du kompletterar <router-link class="link link--green" to="/assets">Dina uppgifter</router-link>.
            </p>
          </span>
        </div>
      </div>

      <TrafficLight class="card__singular--list__container__traffic" v-if="options.trafficLightStatus != null" :rate="options.trafficLightStatus"/>
    </section>

    <section class="card__singular" v-else>
      <div class="card__singular--regular" v-if="options.dataType === 'regular'">
        <div>
          <p class="card__subtitle"> {{ options.items[0].subtitle }} </p>

          <span class="card__data">
            <p :class="'card__value-' + options.items[0].valueType">
              {{ options.items[0].value }}
            </p>

            <img
              v-if="options.items[0].info"
              class="card__info-image"
              src="../../assets/img/info.png"
              alt="info"
            >
          </span>
        </div>

        <img v-if="options.items[0].imageURL != null" :src="options.items[0].imageURL" />
        <TrafficLight class="card__singular--list__container__traffic" v-if="options.trafficLightStatus != null" :rate="options.trafficLightStatus"/>
      </div>

      <div class="card__singular--list" v-if="options.dataType === 'list'">
        <div class="card__singular--list__content">
          <div v-if="Object.keys(options.items[0].listItems).length === 0">
            <p class="card__subtitle card__singular--list__sub"> Vi kunde inte hitta någon </p>
            <a class="card__singular--list__link" href="#"> se alternativ</a>
          </div>

          <div class="card__singular--list__container" v-else>
            <div>
              <p class="card__singular--list__item">
                <img
                  src="../../assets/svg/checkmark-solid.svg"
                  v-if="options.items[0].listItems.hasSjukforsakring"
                >
                <img src="../../assets/svg/circle-times-solid.svg" v-else>

                Sjukförsäkring
              </p>

              <p class="card__singular--list__item">
                <img
                  src="../../assets/svg/checkmark-solid.svg"
                  v-if="options.items[0].listItems.hasEfterlevnadsskydd"
                >
                <img src="../../assets/svg/circle-times-solid.svg" v-else>

                Efterlevnadsskydd
              </p>
            </div>

            <TrafficLight class="card__singular--list__container__traffic" v-if="options.trafficLightStatus != null" :rate="options.trafficLightStatus"/>
          </div>
        </div>
      </div>
    </section>
  </article>
</template>

<script>
import TrafficLight from './../elements/TrafficLights.vue';

export default {
  name: 'RegularCard',
  props: [ 'options' ],
  components: { TrafficLight, }
}
</script>

<style lang="scss" scoped>
.card {
  position: relative;

  &__link {
    height: 100%;
    width: 100%;
    display: block;
    position: absolute;
    top: 0;
    left: 0;
  }

  &__heading-content {
    display: flex;
    justify-content: space-between;
  }

  &__show-more {
    font-family: 'Roboto-Light', sans-serif;
    font-size: .75rem;
    text-decoration: none;
    color: $gray;
    height: .75rem;
  }

  &__updated {
    font-size: .75rem;
    display: flex;
    align-items: center;
    height: .75rem;

    &-img {
      margin-left: .5rem;
      height: .75rem;
    }
  }

  &__multiple {
    display: flex;
    flex-direction: column;
    width: 90%;

    @include breakpoints(small) {
      flex-direction: row;

      div:not(:first-of-type) {
        margin-top: 0;
      }
    }
  }

  &__singular {
    &--regular {
      display: flex;
      justify-content: space-between;
    }

    &--list {
      display: flex;

      &__sub {
        padding: 0;
      }

      &__content {
        display: flex;
        align-items: center;
        width: 100%;
      }

      &__container {
        display: flex;
        justify-content: space-between;
        width: 100%;
      }

      &__item {
        display: flex;
        align-items: center;
        margin-bottom: 12px;

        img {
          margin-right: 1rem;
        }
      }

      &__list {
        font-family: 'Roboto-Light', sans-serif;
        list-style: none;
        padding: 0;
        margin: 0;

        li:not(:first-of-type) {
          margin-top: .5rem;
        }

        &-item {
          display: flex;
          align-items: center;

          &:before {
            content: url('../../assets/svg/checkmark-solid.svg');
            margin-right: 1rem;
          }
        }
      }

      &__link {
        font-family: 'Roboto-Light', sans-serif;
        font-size: 1.5rem;
        text-decoration: none;
        color: $gray;

        @include breakpoints(medium) {
          font-size: 2rem;
        }
      }

      &__image {
        height: 100%;
        align-self: center;
        margin-right: 1rem;

        @include breakpoints(medium) {
          margin-right: 2rem;
        }
      }
    }
  }

  &__data {
    display: flex;
  }

  &__no-value {
    margin-top: .75rem;
    font-size: 1rem;
    color: $gray;
  }

  &__value {
    &-sek {
      font-size: 2.5rem;
      display: flex;
      align-items: baseline;

      &::after {
        content: ' KR';
        font-size: 1.5rem;
        margin-left: 5px;
      }
    }

    &-percent {
      font-size: 2.5rem;
      display: flex;
      align-items: baseline;

      &::after {
        content: '%';
        font-size: 2.5rem;
      }
    }

    &-monthly {
      font-size: 2.5rem;
      display: flex;
      align-items: baseline;

      &::after {
        content: ' kr/m';
        font-size: 1.5rem;
        margin-left: 5px;
      }
    }
  }

  &__items {
    display: flex;

    div:not(:first-of-type) {
      margin-top: 1rem;

      @include breakpoints(small) {
        margin-top: 0;
        margin-left: 2.5rem;
      }
    }

    .card__value-monthly {
      font-size: 2.5rem;

      &::after {
        content: ' kr/m';
        font-size: 1.5rem;
        margin-left: 5px;
      }
    }

    .card__value-sek {
      font-size: 2.5rem;

      &::after {
        font-size: 1.5rem;
        margin-left: 5px;
      }
    }

    .card__value-percent {
      font-size: 2.5rem;

      &::after {
        font-size: 2.5rem;
      }
    }
  }

  &__item {
    width: 100%;

    @include breakpoints(medium) {
      width: 50%;
    }
  }

  &__info-image {
    height: 15px;
  }
}
</style>